export default "__VITE_ASSET__DkEaZ4z7__"